import { render, staticRenderFns } from "./v1_mobile.vue?vue&type=template&id=28b6b8ec&"
import script from "./v1_mobile.vue?vue&type=script&lang=js&"
export * from "./v1_mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports